import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Footer, Scroller, SubNavBar } from '..';
import {
  PUBLIC_PAGE_DATA_GET,
  PUBLIC_PAGE_DETAILS_GET,
} from '../../../app/redux/actions/public';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import { LinearLoader } from '../Loader';
import { PageContainer } from '../GlobalLayout/styles';
import NavBarPublic from '../NavBarPublic';
import FaqBanner from '../FaqBanner';
import NavbarEnv from '../NavbarEnv';

const GlobalLayoutPublic = ({
  menuLinks,
  menuLogo,
  footer,
  subFooter,
  isLoading,
  isLogged,
}) => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <NavBarPublic isLogged={isLogged} />
      <NavbarEnv />
      <SubNavBar menuLogo={menuLogo} menuLinks={menuLinks} />
      {isLoading && <LinearLoader />}
      <PageContainer id="anchor">
        <Outlet />
      </PageContainer>
      <FaqBanner />
      <Scroller />
      <Footer footer={footer} subFooter={subFooter} />
    </>
  );
};

GlobalLayoutPublic.propTypes = {
  menuLinks: PropTypes.array,
  menuLogo: PropTypes.object,
  footer: PropTypes.array,
  subFooter: PropTypes.array,
  isLoading: PropTypes.bool,
  isLogged: PropTypes.bool,
};

export default compose(
  connect(
    (state) => {
      const { menuLogo, menuLinks, footer, subFooter } = state.publicSite;
      const { navigationMobile } = state.app;
      const { isSpinning: isLoading } = state.app.loader;
      const { isLogged } = state.app.authState;
      return {
        menuLogo,
        menuLinks,
        footer,
        subFooter,
        navigationMobile,
        isLoading,
        isLogged,
      };
    },
    (dispatch) => ({
      getPageDetails: (id) =>
        dispatch({ type: PUBLIC_PAGE_DETAILS_GET._REQUEST, id }),
    })
  ),
  withMediaQueries
)(GlobalLayoutPublic);
